import { useMutation, useQuery } from '@tanstack/react-query';
import { ERROR_DIALOG } from 'gcs-common/constants/errorDialogConstants';
import { useHandleQueryError } from 'gcs-common/helper/errorMessages';
import type { Parameters } from '../../../../../types/typeHelper';
import { useApiClient } from '../../client';

export enum ChannelClientQueryKeys {
  INFO_PANEL_DETAILS = 'INFO_PANEL_DETAILS',
}

export function useStartTypingMutation() {
  const client = useApiClient();
  return useMutation({
    mutationFn: async ({
      params,
    }: {
      params: Parameters<'/chat/channels/{channel_id}/start-typing', 'put'>;
    }) => {
      return client.PUT('/chat/channels/{channel_id}/start-typing', {
        params,
      });
    },
  });
}

export function useInfoPanelDetails(channelId: string) {
  const client = useApiClient();
  const handleQueryError = useHandleQueryError();
  return useQuery({
    queryKey: [ChannelClientQueryKeys.INFO_PANEL_DETAILS, channelId],
    queryFn: async () => {
      const { data, error } = await client.GET('/chat/channels/{channel_id}/info-panel-details', {
        params: { path: { channel_id: channelId } },
      });
      handleQueryError({
        errorDialog: ERROR_DIALOG.NONE,
        // @ts-expect-error mismatch between openapi-fetch error and backend error types
        error,
      });

      return data;
    },
    enabled: !!channelId,
  });
}
